import { render, staticRenderFns } from "./TiXianQuestion.vue?vue&type=template&id=2a5dcbc5&scoped=true&"
import script from "./TiXianQuestion.vue?vue&type=script&lang=js&"
export * from "./TiXianQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TiXianQuestion.vue?vue&type=style&index=0&id=2a5dcbc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5dcbc5",
  null
  
)

export default component.exports